import { DialogDescription, DialogTitle, DialogHeader as UIDialogHeader } from '@zond/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface DialogHeaderProps {
  integrationName: string;
  logoUrl: string;
}

export function DialogHeader({ integrationName, logoUrl }: DialogHeaderProps) {
  const { t } = useTranslation('integrations');
  const [imageError, setImageError] = useState(false);

  return (
    <UIDialogHeader className="px-6 pt-6 pb-2">
      <div className="flex items-center gap-4">
        <div className="flex size-10 items-center justify-center rounded-lg bg-muted p-2">
          {imageError ? (
            <div className="text-sm font-medium">{integrationName.slice(0, 2).toUpperCase()}</div>
          ) : (
            <img
              src={logoUrl}
              alt={t('appCard.logoAlt', { name: integrationName })}
              className="size-full object-contain"
              onError={() => setImageError(true)}
            />
          )}
        </div>
        <div className="flex-1">
          <DialogTitle className="flex items-center gap-2">
            {t('dialog.title', { name: integrationName })}
          </DialogTitle>
          <DialogDescription>
            {integrationName.toLowerCase() === 'github'
              ? t('dialog.descriptionGithub')
              : t('dialog.description', { name: integrationName })}
          </DialogDescription>
        </div>
      </div>
    </UIDialogHeader>
  );
}
